import { InputTextField } from '@abbott-components/core';
import {
  SelectChangeEvent,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useState } from 'react';
import { GridSize } from './Enums/gridSize';
import { useFormContext } from 'react-hook-form';
import SelectIE, { SelectIEEvent } from './SelectIE';

export interface SizingSelectProps {
  isReadOnlyView: boolean;
  name: string;
  sizingSelectOnChange?: (size: string) => void;
}

export default function SizingSelect({
  isReadOnlyView,
  name,
  sizingSelectOnChange
}: SizingSelectProps) {
  const formContext = useFormContext();
  const [sizeValue, setSizeValue] = useState(
    formContext.getValues(name) ? formContext.getValues(name) : 12
  );

  const handleTimeFormatChange = (event: SelectChangeEvent | SelectIEEvent) => {
    formContext.setValue(name, event.target.value);
    setSizeValue(event.target.value);
    if (sizingSelectOnChange) {
      sizingSelectOnChange(event.target.value);
    }
  };
  const isIe = /MSIE|Trident/.test(window.navigator.userAgent);
  return (
    <Stack sx={{ flexGrow: 4, paddingTop: '1rem', minWidth: '20%' }}>
      {isIe ? (
        <SelectIE
          selectedValue={sizeValue}
          SelectProps={{ label: 'Grid Size' }}
          onChange={handleTimeFormatChange}
        >
          <MenuItem value={GridSize.FULL}>Full</MenuItem>
          <MenuItem value={GridSize.HALF}>1/2</MenuItem>
          <MenuItem value={GridSize.QUARTER}>1/3</MenuItem>
          <MenuItem value={GridSize.THIRD}>1/4</MenuItem>
          <MenuItem value={GridSize.TWO_THIRDS}>2/3</MenuItem>
        </SelectIE>
      ) : (
        <FormControl disabled={isReadOnlyView} fullWidth>
          <InputLabel>Size</InputLabel>
          <Select
            label="Grid Size"
            value={sizeValue}
            onChange={handleTimeFormatChange}
            disabled={isReadOnlyView}
          >
            <MenuItem value={GridSize.FULL}>Full</MenuItem>
            <MenuItem value={GridSize.HALF}>1/2</MenuItem>
            <MenuItem value={GridSize.QUARTER}>1/3</MenuItem>
            <MenuItem value={GridSize.THIRD}>1/4</MenuItem>
            <MenuItem value={GridSize.TWO_THIRDS}>2/3</MenuItem>
          </Select>
        </FormControl>
      )}
      <InputTextField name={name} label="Grid Size" sx={{ display: 'none' }} />
    </Stack>
  );
}
